const logoWrapper = document.querySelector('.logos-track');
const logoSlides = document.querySelectorAll('.logo-wrapper');
const stepper = document.querySelectorAll('ul.stepper-container > li');
const stepperContainer = document.querySelectorAll('.logo-stepper-container');

const singleSlideWidth = logoSlides[0].offsetWidth;
const slidesLength = logoSlides.length;
const initPosition = 0;

let slideInterval;
let currentSlideIndex = 0;

// --- Initialize Stepper ---
if (stepper.length > 0) {
    stepper[0].classList.add('active');
    stepper.forEach((element, index) => {
        element.addEventListener('click', () => {
            showSlideLogo(index);
            restartAutoSlide(index);
        });
    });
}

function setActiveLogoStepper(activeIndex) {
    stepper.forEach((element, index) => {
        element.classList.toggle('active', index === activeIndex);
    });
}

// --- Initialize Slider ---
function initLogoSlider() {
    if (!logoWrapper || logoSlides.length === 0) return;

    stepperContainer.forEach(container => {
        container.style.display = 'none';
    });

    if (logoSlides.length > 3 || window.innerWidth < 768) {
        stepperContainer.forEach(container => {
            container.style.display = 'flex';
        });
    }

    logoWrapper.style.left = `${initPosition}px`;

    const slidesWidth = singleSlideWidth * logoSlides.length;
    const containerWidth = logoWrapper.offsetWidth;

    document.querySelectorAll('.logo-logoWrapper.clone').forEach(element => element.remove());

    if (slidesWidth > containerWidth) {
        logoSlides.forEach(element => {
            const cloned = element.cloneNode(true);
            cloned.classList.add('clone');
            logoWrapper.appendChild(cloned);
        });
    }
}

function showSlideLogo(index) {
    const widthToMove = singleSlideWidth + 12;
    currentSlideIndex = index;

    setActiveLogoStepper(index);

    logoWrapper.style.transition = 'transform 0.6s ease';
    logoWrapper.style.transform = `translateX(${-index * widthToMove}px)`;
}

// --- Auto slide logos ---
function slidePartnersLogo(startFrom = 0) {
    clearInterval(slideInterval);

    const slidesWidth = singleSlideWidth * logoSlides.length;
    const containerWidth = logoWrapper.offsetWidth;

    if (slidesWidth > containerWidth) {
        let i = startFrom;

        slideInterval = setInterval(() => {
            i = (i + 1) % slidesLength;
            showSlideLogo(i);
        }, 4000);
    }
}

// --- Restart auto slide from specific index ---
function restartAutoSlide(startFrom = 0) {
    clearInterval(slideInterval);
    slidePartnersLogo(startFrom);
}

// --- Initialize everything ---
initLogoSlider();
slidePartnersLogo();

window.addEventListener('resize', () => {
    initLogoSlider();
    slidePartnersLogo(currentSlideIndex);
});
